import {
    request,
    requestMedia,
    requestPost
}
    from './request';

export default {
    listPer(data) {
        return request ('/api/permission-config/list',data)
    },
    deletePer(id) {
        return request('/api/permission-config/delete/'+id)
    },
    updatePer(data) {
        return request('/api/permission-config/update',data)
    },
    listRole(){
        return request("/api/permission-config/getAllPermission")
    },
    addAccount(data) {
        return request("/api/permission-config/save",data)
    },
    getPerById(id) {
        return request("/api/permission-config/get/"+id)
    }
}


// WEBPACK FOOTER //
// ./src/libs/axios/permission.js